import { onMounted, ref } from "vue";
import { queryStashList } from "@/api/stash";

export default function useStashList() {
  const stashList = ref([]);

  const getStashList = () => {
    queryStashList({ page: 1, limit: 99 }).then((res) => {
      stashList.value = res.data.records;
    });
  };

  onMounted(() => {
    getStashList();
  });

  return {
    stashList,
  };
}
